import * as S from './style'
import LayoutDetails from '../../../../components/LayoutModal/LayoutDetails';
import axiosInstance from 'services/axiosInstance';
import { useEffect, useState } from 'react';
import Loading from '../../../../components/Loading';
import useLoading from "../../../../hooks/useLoading";
//Interface
import { IData } from 'Interfaces/IAccessory';
//Utils
import { CurrencyFormat } from 'utils/CurrencyFormat';
import FormatarData from 'utils/FormatData';

interface IDetails {
    isOpenModal: boolean;
    setModalClose: () => void;
    selectedUrlId: number | null;
}

export default function Details({ isOpenModal, setModalClose, selectedUrlId }: IDetails) {
    const [data, setData] = useState<IData | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`accessory/${selectedUrlId}`);
            setData(response.data);
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        if (selectedUrlId !== null) {
            fetchData();
        }
    }, [selectedUrlId])

    if (isOpenModal) {
        return (
            <LayoutDetails
                title='Detalhes do Acessório'
                subTitle='Veja todos os detalhes disponíveis sobre o Acessório.'
                setModalClose={setModalClose}>
                {isLoading || !data ? (
                    <Loading />
                ) : (
                    <S.Content>
                        <S.Infor>
                            <p>Nome:</p>
                            <span>{data.name || '-'}</span>
                        </S.Infor>
                        <S.Infor>
                            <p>Quantidade:</p>
                            <span>{data.amount || '-'}</span>
                        </S.Infor>
                        <S.Infor>
                            <p>Preço:</p>
                            <span>{CurrencyFormat(parseFloat(data.price) || 0) || '-'}</span>
                        </S.Infor>

                        <S.InforBody>
                            <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                            <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                        </S.InforBody>
                    </S.Content>
                )}
            </LayoutDetails>
        )
    } return null
}